import { useQuery } from "react-query";
import { getOfficeImageCategory } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeImageCategory = () => {
  return useQuery("GetOfficeImageCategory", getOfficeImageCategory, {
    refetchOnWindowFocus: false,
  });
};
